module.exports = __webpack_public_path__ + "b893167fb3b0bcf9a3bdcb2518152105.svg";